<template>
  <slot />
</template>

<script setup lang="ts">
import type { SectionProvider } from '#content/contexts/section'
import { SectionContextKey } from '#content/contexts/section'

const { index } = defineProps<{ index: number }>()

const section = inject(SectionContextKey, {} as SectionProvider)

provide(SectionContextKey, {
  ...section,
  position: index
})
</script>`
